import { useState } from 'react';
import { IconPlus } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { useLocale } from 'hooks/useLocale';
import { useFormContext } from 'react-hook-form';
import { TSignupFormDataDE } from '../NewSignupFormDE/NewSignupFormDE.types';
import { TSignupFormData } from '../SignupForm/SignupForm';
import styles from '../SignupForm/SignupForm.module.css';

export const DevTimeSaver = () => {
  const [hideDeveloperConfig, setHideDeveloperConfig] = useState(false);

  const { isUK } = useLocale();

  const methods = useFormContext<TSignupFormData | TSignupFormDataDE>();

  const isNonProductionEnv = () => {
    if (typeof window === 'undefined') return;

    return (
      window.location.host === 'stage.iwoca-dev.de' ||
      window.location.host === 'stage.iwoca-dev.co.uk' ||
      window.location.host.includes('localhost') ||
      window.location.host.endsWith('coder-v2.iwoca.com')
    );
  };

  // Temporary developer view to autofill all the fields
  const handleAintGotTimeForThat = () => {
    if (isUK) {
      methods.setValue('companyType', 'limited_liability_company');
      methods.setValue('startDateMonth', '02');
      methods.setValue('startDateYear', '1990');
      methods.setValue('companyName', 'Company Name');
      methods.setValue('companyNumber', '01111112');
      methods.setValue('last12MonthsTurnover', '1400000');
      methods.setValue('isVatRegistered', 'true');
      methods.setValue('tradingName', 'Mcdonalds');
      methods.setValue('website', 'https://www.crazygames.com/game/mcdonalds');
      methods.setValue('applicant.roles', [
        'applicant',
        'guarantor',
        'director',
      ]);
      methods.setValue('applicant.firstName', 'Ervin');
      methods.setValue('applicant.lastName', 'Norton');
      methods.setValue('applicant.dobDay', '01');
      methods.setValue('applicant.dobMonth', '01');
      methods.setValue('applicant.dobYear', '1980');
      methods.setValue('applicant.phoneNumber', '0123456789');
      methods.setValue('applicant.email', 'w.tong+test@iwoca.co.uk');
      methods.setValue('applicant.residentialAddresses.0.house_number', '286');
      methods.setValue('applicant.residentialAddresses.0.house_name', '');
      methods.setValue(
        'applicant.residentialAddresses.0.street_line_1',
        'Idverifier St',
      );
      methods.setValue('applicant.residentialAddresses.0.street_line_2', '');
      methods.setValue('applicant.residentialAddresses.0.town', 'Ely');
      methods.setValue('applicant.residentialAddresses.0.postcode', 'CB6 2AG');
      methods.setValue(
        'applicant.residentialAddresses.0.residential_status',
        'owner_with_mortgage',
      );
      methods.setValue('applicant.privacyPolicyAgreement', true);
      methods.setValue('amount', '10000');
      methods.setValue('loanPurpose', 'other');
      methods.setValue('loanDuration', '12-months');
      methods.setValue(
        'loanPurposeDetails',
        `I really want a loan to buy a McDonald's franchise`,
      );
    }

    if (!isUK) {
      methods.setValue('company.name', 'my company');
      methods.setValue('company.crefoId', '11111111111111');
      methods.setValue('company.street', 'Wetteraustraße');
      methods.setValue('company.buildingNumber', '1');
      methods.setValue('company.postcode', '60311');
      methods.setValue('company.town', 'Frankfurt');
      methods.setValue('company.legalForm', 'freiberufler');
      methods.setValue('company.tradingFromMonth', '01');
      methods.setValue('company.tradingFromYear', '1999');
      methods.setValue('company.last12MonthsTurnover', '700000');
      methods.setValue('company.website', 'https://my-company.de');
      methods.setValue('applicant.roles', [
        'applicant',
        'guarantor',
        'director',
      ]);
      methods.setValue('applicant.title', 'herr');
      methods.setValue('applicant.firstName', 'Peter');
      methods.setValue('applicant.lastName', 'Norton');
      methods.setValue('applicant.dobDay', '01');
      methods.setValue('applicant.dobMonth', '01');
      methods.setValue('applicant.dobYear', '1980');
      methods.setValue('applicant.phoneNumber', '0234567890');
      methods.setValue('applicant.email', 'peter@iwoca.de');
      methods.setValue('applicant.residentialAddresses.0.house_number', '24');
      methods.setValue(
        'applicant.residentialAddresses.0.street_line_1',
        'Hauptstraße',
      );
      methods.setValue('applicant.residentialAddresses.0.town', 'Mayen');
      methods.setValue('applicant.residentialAddresses.0.postcode', '56727');
      methods.setValue('applicant.privacyPolicyAgreement', true);
      methods.setValue('amount', '10000');
      methods.setValue('loanPurpose', 'other');
      methods.setValue('loanDuration', '12-months');
      methods.setValue(
        'loanPurposeDetails',
        `I really want a loan to buy a McDonald's franchise`,
      );
    }
  };

  if (hideDeveloperConfig || !isNonProductionEnv()) {
    return null;
  }

  return (
    <div className={styles.temporaryDevButton}>
      <IconPlus
        className={styles.temporaryDevButtonClose}
        onClick={() => setHideDeveloperConfig(true)}
      />
      <h3>Developer Config</h3>
      <Button size="small" onClick={handleAintGotTimeForThat}>
        Nobody got time for dat
      </Button>
      <Button size="small" onClick={() => methods.setValue('amount', '100000')}>
        Update to manual
      </Button>
      <Button
        size="small"
        onClick={() => console.log('value', methods.getValues())}
      >
        Get value in console
      </Button>
    </div>
  );
};
